import { z } from 'zod';

import { api } from '@/api/client';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';
import { categoryModelsResponseSchema, type CategoryModelsResponse } from '@/schemas/categoryModels';

export const getCategoryModelsParamsSchema = z.object({
  redeId: z.string().optional(),
  escolaId: z.number().int().optional(),
  anoEscolarId: z.number().int().optional(),
  turmaId: z.number().int().optional(),
  alunoId: z.number().int().optional(),
  anoLetivo: z.string().optional(),
});

export type GetCategoryModelsParams = z.infer<typeof getCategoryModelsParamsSchema>;

export const getCategoryModels = async (params?: GetCategoryModelsParams): Promise<CategoryModelsResponse> => {
  const mapParams = (params?: GetCategoryModelsParams) => ({
    redeId: params?.redeId,
    escolaId: params?.escolaId,
    anoEscolarId: params?.anoEscolarId,
    turmaId: params?.turmaId,
    alunoId: params?.alunoId,
    anoLetivo: params?.anoLetivo,
  });

  const res = await api.get<CategoryModelsResponse>('/v3/dashboard/resultado/categorias-modelos', {
    params: mapParams(params),
  });

  if (!res.data) {
    throw new Error('No data received from API');
  }

  return categoryModelsResponseSchema.parse(res.data);
};

export type GetCategoryModelsLogadoParams = { anoLetivo: string };

export const getCategoryModelsLogado = httpGetAdapter<CategoryModelsResponse, GetCategoryModelsLogadoParams>({
  url: '/v3/dashboard/resultado/categorias-modelos/logado',
  schema: categoryModelsResponseSchema,
  mapParams: (params) => ({ anoLetivo: params.anoLetivo }),
});
